import BaseEntity from '../../base/BaseEntity.model';
import SolicitudCambioComposicionFamiliarInclusion from './inclusion.model';
import SolicitudCambioComposicionFamiliarExclusion from './exclusion.model';
import SolicitudCambioComposicionFamiliarCorreccion from './correccion.model';
import SolicitudCambioComposicionFamiliarDocumento from './documento.model';

export default class SolicitudCambioComposicionFamiliar extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public inclusion?: boolean;
    public exclusion?: boolean;
    public correccion?: boolean;
    public miembrosCorregidos: SolicitudCambioComposicionFamiliarCorreccion[];
    public miembrosIncluidos: SolicitudCambioComposicionFamiliarInclusion[];
    public miembrosExcluidos: SolicitudCambioComposicionFamiliarExclusion[];

    constructor(public hogarId: number | undefined = undefined) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.inclusion = undefined;
        this.exclusion = undefined;
        this.correccion = undefined;
        this.miembrosIncluidos = [];
        this.miembrosExcluidos = [];
        this.miembrosCorregidos = [];
    }
}

export {
    SolicitudCambioComposicionFamiliarInclusion,
    SolicitudCambioComposicionFamiliarExclusion,
    SolicitudCambioComposicionFamiliarCorreccion,
    SolicitudCambioComposicionFamiliarDocumento
}